import { PortCall } from 'data/models/PortCall';

import { EventLog, EventLogParams } from 'portcall/eventlog/model';
import { NewComment, NewCommentParams } from 'portcall/eventlog/newcomment';

export interface PortCallLogParams { 
    portcall : PortCall
}

export type PortCallLog = ReturnType<typeof PortCallLog>;
export function PortCallLog(
    newCommentModel : (params : NewCommentParams) => NewComment,
    eventLogModel : (params : EventLogParams) => EventLog,
    { portcall } : PortCallLogParams
) {
    const
        EventLog = eventLogModel({
            log: portcall.Log,
            canComment: () => true
        }),
        NewComment = newCommentModel({
            url: () => portcall.Self()?.CommentsUrl() ?? '',
        });

    return { EventLog, NewComment };
}



// WEBPACK FOOTER //
// ./apps/portcall/portcalllog/model.ts